import * as Sentry from '@sentry/browser'
import { BrowserTracing } from '@sentry/tracing'

Sentry.init({
  dsn: window.SENTRY_FRONTEND_DSN,
  environment: window.ENVIRONMENT,
  integrations: [new BrowserTracing()],
  tracesSampleRate: 0.5
})
Sentry.setUser({ id: window.CURRENT_USER_ID, username: window.CURRENT_USER_NAME })
// window.Sentry = Sentry
